import { StudioAllocatorSubject } from './StudioAllocatorSubject';
import React from 'react';
import { StudioAllocatorWindow } from './components';

interface ShimmerPanelProps {
  isPrivate?: boolean;
}
export const StudioAllocationPanelShimmerBlock = ({ isPrivate }: ShimmerPanelProps) => {
  return (
    <StudioAllocatorWindow>
      <StudioAllocatorSubject isPrivate={isPrivate} disabled />
    </StudioAllocatorWindow>
  );
};
